module.exports = __webpack_public_path__ + "img/5.5343d4a8.jpg";